import { render, staticRenderFns } from "./PrintLabelArticle.vue?vue&type=template&id=359f516c"
import script from "./PrintLabelArticle.vue?vue&type=script&lang=js"
export * from "./PrintLabelArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports